export default "__VITE_ASSET__C0MtuQjI__"